(() => {
  'use strict';
  const messages = JSON.parse(document.getElementById('soluveli-i18n').textContent);
  const language = document.documentElement.lang.split('-')[0];
  const localePlurals = ['cs', 'ro'].includes(language) ? new Intl.PluralRules(language) : null;
  const tr = (key, count) => {
    const variant = localePlurals && Number.isFinite(count)
      ? messages[`${key.replace(/_(one|other)$/, '')}_${localePlurals.select(count)}`]
      : null;
    return (variant || messages[key] || '').replace('{count}', String(count ?? ''));
  };
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const header = document.querySelector('.site-header-section');
  const announcement = header?.querySelector('.announcement');
  const menu = document.getElementById('mobile-nav');
  const toggle = document.querySelector('[data-menu-toggle]');
  const body = document.querySelector('[data-article-body]');
  const sourceDisclosures = [];
  body?.querySelectorAll('.article-references').forEach(section => {
    const heading = section.querySelector(':scope > h2');
    const list = section.querySelector(':scope > ol, :scope > ul');
    if (!heading || !list) return;
    const details = document.createElement('details');
    details.className = 'article-sources';
    const summary = document.createElement('summary');
    summary.className = 'article-sources-summary';
    const count = document.createElement('span');
    count.className = 'article-sources-count';
    const total = list.querySelectorAll(':scope > li').length;
    count.textContent = tr(total === 1 ? 'source_one' : 'source_other', total);
    const mark = document.createElement('span');
    mark.className = 'article-sources-mark';
    mark.setAttribute('aria-hidden', 'true');
    summary.append(heading, count, mark);
    const content = document.createElement('div');
    content.className = 'article-sources-content';
    content.append(...section.childNodes);
    details.append(summary, content);
    section.append(details);
    sourceDisclosures.push(details);
  });
  const revealSource = hash => {
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return null; }
    const target = id && document.getElementById(id);
    const details = target && target.closest('.article-sources');
    if (!details || details.open) return null;
    details.open = true;
    return target;
  };
  const toc = document.querySelector('[data-article-toc]');
  const progress = document.querySelector('[data-reading-progress]');
  const headings = body ? [...body.querySelectorAll('h2')] : [];
  const contents = toc?.closest('details');
  const readerControls = document.querySelector('.reader-controls');
  const readerType = document.querySelector('[data-reader-type]');
  const tocPosition = document.querySelector('[data-toc-position]');
  const wideArticle = window.matchMedia('(min-width: 980px)');
  let headerHeight = 0;
  let fullHeaderHeight = 0;
  let announcementHeight = 0;
  let readerHeight = 0;
  let measuredAnnouncementHeight = -1;
  let measuredReaderHeight = -1;
  let measureHeaderNeeded = true;
  let scrollQueued = false;
  let activeHeading = '';
  const measureHeader = () => {
    measureHeaderNeeded = true;
    queueScroll();
  };
  const setMenu = (open, restoreFocus = false) => {
    if (!menu || !toggle) return;
    menu.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? tr('menu_close') : tr('menu_open'));
    header.classList.toggle('menu-is-open', open);
    if (restoreFocus) toggle.focus();
  };
  toggle?.addEventListener('click', () => setMenu(menu.hidden));
  document.addEventListener('soluveli:region-open', () => setMenu(false));
  menu?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu && !menu.hidden) setMenu(false, true);
  });
  document.addEventListener('click', event => {
    if (menu && !menu.hidden && !header.contains(event.target)) setMenu(false);
  });
  document.addEventListener('focusin', event => {
    if (menu && !menu.hidden && !header.contains(event.target)) setMenu(false);
  });
  window.matchMedia('(min-width: 901px)').addEventListener('change', event => {
    if (event.matches) setMenu(false);
  });
  if (header && 'ResizeObserver' in window) new ResizeObserver(measureHeader).observe(header);
  if (sourceDisclosures.length) {
    document.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
      if (link.origin === location.origin && link.pathname === location.pathname && link.search === location.search) revealSource(link.hash);
    }, true);
    const followSourceHash = () => {
      const target = revealSource(location.hash);
      if (target) requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'instant' }));
    };
    window.addEventListener('hashchange', followSourceHash);
    followSourceHash();
    let sourcePrintState = [];
    window.addEventListener('beforeprint', () => {
      sourcePrintState = sourceDisclosures.map(details => details.open);
      sourceDisclosures.forEach(details => { details.open = true; });
    });
    window.addEventListener('afterprint', () => {
      sourceDisclosures.forEach((details, index) => { details.open = sourcePrintState[index] ?? details.open; });
    });
  }
  if (toc && headings.length) {
    contents.hidden = false;
    toc.replaceChildren();
    headings.forEach((heading, index) => {
      if (!heading.id) {
        let candidate = `artikel-${index + 1}`;
        while (document.getElementById(candidate)) candidate += '-kop';
        heading.id = candidate;
      }
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      const number = document.createElement('span');
      number.className = 'toc-number';
      number.setAttribute('aria-hidden', 'true');
      number.textContent = String(index + 1).padStart(2, '0');
      const label = document.createElement('span');
      label.textContent = heading.textContent;
      link.append(number, label);
      link.addEventListener('click', () => {
        if (!wideArticle.matches) contents.open = false;
        heading.tabIndex = -1;
        heading.focus({ preventScroll: true });
      });
      toc.append(link);
    });
    contents.open = wideArticle.matches;
    if (tocPosition) tocPosition.textContent = tr('sections', headings.length);
    wideArticle.addEventListener('change', event => { contents.open = event.matches; measureHeader(); });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && contents.open && !wideArticle.matches) {
        contents.open = false;
        contents.querySelector('summary').focus({ preventScroll: true });
      }
    });
    const closeContentsOutside = event => {
      if (!wideArticle.matches && contents.open && !contents.contains(event.target)) contents.open = false;
    };
    document.addEventListener('click', closeContentsOutside);
    document.addEventListener('focusin', closeContentsOutside);
  }
  if (readerType && body) {
    readerType.hidden = false;
    readerType.addEventListener('click', () => {
      const readingLine = headerHeight + readerHeight + 24;
      const visible = [...body.querySelectorAll('p,h2,h3,li')].find(element => element.getBoundingClientRect().bottom > readingLine);
      const previousTop = visible?.getBoundingClientRect().top;
      const larger = document.body.classList.toggle('reading-large');
      readerType.setAttribute('aria-pressed', String(larger));
      const label = larger ? tr('text_standard') : tr('text_larger');
      readerType.setAttribute('aria-label', label);
      readerType.title = label;
      readerType.querySelector('.reader-type-label').textContent = label;
      document.querySelector('[data-reader-status]').textContent = larger ? tr('text_larger_status') : tr('text_standard_status');
      if (visible && body.getBoundingClientRect().top < readingLine) window.scrollBy({ top: visible.getBoundingClientRect().top - previousTop, behavior: 'instant' });
      queueScroll();
    });
    if ('ResizeObserver' in window) new ResizeObserver(measureHeader).observe(readerControls);
  }
  const updateScroll = () => {
    scrollQueued = false;
    // Read geometry together, after the other deferred modules have built their
    // UI. Writing a header variable between these reads forced full-page layout.
    const scrollY = window.scrollY;
    if (measureHeaderNeeded) {
      fullHeaderHeight = header?.getBoundingClientRect().height || 0;
      announcementHeight = announcement?.getBoundingClientRect().height || 0;
      readerHeight = readerControls && !wideArticle.matches ? Math.ceil(readerControls.getBoundingClientRect().height) : 0;
      measureHeaderNeeded = false;
    }
    const visibleHeight = Math.ceil(fullHeaderHeight - Math.min(Math.max(0, scrollY), announcementHeight));
    const readingTop = visibleHeight + readerHeight;
    let fraction = 0;
    let current = '';
    if (body && progress) {
      const rect = body.getBoundingClientRect();
      const distance = Math.max(1, rect.height - window.innerHeight + readingTop);
      fraction = Math.min(1, Math.max(0, (readingTop - rect.top) / distance));
      for (const heading of headings) {
        const start = heading.closest('.article-callout') || heading;
        if (start.getBoundingClientRect().top <= readingTop + 72) current = heading.id;
        else break;
      }
    }
    // Only change styles that actually changed. All layout reads precede writes.
    if (header && announcementHeight !== measuredAnnouncementHeight) {
      measuredAnnouncementHeight = announcementHeight;
      header.style.setProperty('--announcement-height', `${announcementHeight}px`);
    }
    if (visibleHeight !== headerHeight) {
      headerHeight = visibleHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
    if (body && readerHeight !== measuredReaderHeight) {
      measuredReaderHeight = readerHeight;
      document.body.style.setProperty('--reader-offset', `${readerHeight}px`);
    }
    header?.classList.toggle('is-scrolled', scrollY > 24);
    if (!body || !progress) return;
    progress.style.setProperty('--reading-progress', fraction.toFixed(4));
    if (current !== activeHeading) {
      activeHeading = current;
      if (tocPosition) tocPosition.textContent = current ? `${String(headings.findIndex(heading => heading.id === current) + 1).padStart(2, '0')} / ${String(headings.length).padStart(2, '0')}` : tr('sections', headings.length);
      toc?.querySelectorAll('a').forEach(link => {
        if (link.hash.slice(1) === current) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
  };
  const queueScroll = () => {
    if (!scrollQueued) { scrollQueued = true; requestAnimationFrame(updateScroll); }
  };
  window.addEventListener('scroll', queueScroll, { passive: true });
  window.addEventListener('resize', () => { measureHeader(); queueScroll(); }, { passive: true });
  queueScroll();
  document.querySelectorAll('.day-gallery').forEach(gallery => {
    const viewport = gallery.querySelector('.day-viewport');
    const prev = gallery.querySelector('[data-slot="carousel-previous"]');
    const next = gallery.querySelector('[data-slot="carousel-next"]');
    const track = gallery.querySelector('.day-track');
    if (!viewport || !prev || !next || !track?.firstElementChild) return;
    const update = () => {
      const left = viewport.scrollLeft;
      const maximum = viewport.scrollWidth - viewport.clientWidth;
      prev.disabled = left < 3;
      next.disabled = left >= maximum - 3;
    };
    const move = direction => {
      const step = track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
      viewport.scrollBy({ left: direction * step, behavior: reduced.matches ? 'instant' : 'smooth' });
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    viewport.addEventListener('scroll', update, { passive: true });
    viewport.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
    });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(viewport);
    requestAnimationFrame(update);
  });
  const share = document.querySelector('[data-copy-article]');
  const shareStatus = document.querySelector('[data-share-status]');
  const shareFallback = document.querySelector('.share-fallback');
  if (share && shareStatus && shareFallback) {
    share.hidden = false;
    share.addEventListener('click', async () => {
      const url = document.querySelector('link[rel="canonical"]')?.href || location.href.split('#')[0];
      const title = document.querySelector('meta[property="og:title"]')?.content || document.title;
      const text = document.querySelector('meta[property="og:description"]')?.content || '';
      shareStatus.textContent = '';
      shareFallback.hidden = true;
      if (typeof navigator.share === 'function') {
        try {
          await navigator.share({ title, text, url });
          return;
        } catch (error) {
          // Closing the system share sheet is intentional; leave the clipboard alone.
          if (error.name === 'AbortError') return;
        }
      }
      try {
        await navigator.clipboard.writeText(url);
        share.querySelector('span').textContent = tr('link_copied');
        shareStatus.textContent = tr('copy_success');
        window.setTimeout(() => { share.querySelector('span').textContent = tr('share'); }, 4000);
      } catch {
        shareFallback.hidden = false;
        const input = shareFallback.querySelector('input');
        input.value = url;
        input.focus();
        input.select();
        shareStatus.textContent = tr('copy_fallback');
      }
    });
    document.querySelector('[data-share-close]')?.addEventListener('click', () => { shareFallback.hidden = true; share.focus(); });
  }
  if ('IntersectionObserver' in window && !reduced.matches) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: 0.04 });
    document.querySelectorAll('.reveal').forEach(element => { element.classList.add('reveal-ready'); observer.observe(element); });
  }
  document.querySelectorAll('.launch-form, .soluveli-contact-form').forEach(form => {
    const note = form.querySelector('[data-submit-status]');
    const pendingText = note?.textContent;
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) return;
      if (navigator.onLine === false) {
        event.preventDefault();
        if (note) {
          note.textContent = tr('offline');
          note.hidden = false;
        }
        return;
      }
      if (note) {
        note.textContent = pendingText;
        note.hidden = false;
      }
    });
    window.addEventListener('pageshow', event => {
      if (event.persisted && note) note.hidden = true;
    });
  });
  const status = document.querySelector('[data-form-status]');
  if (status) { status.focus({ preventScroll: true }); status.scrollIntoView({ block: 'center', behavior: 'instant' }); }
})();
